export const GET_ALL_ADMIN_TRACKING = "GET_ALL_ADMIN_TRACKING";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_ADMIN_TRACKING = "START_LOADING_ADMIN_TRACKING";
export const STOP_LOADING_ADMIN_TRACKING = "STOP_LOADING_ADMIN_TRACKING";
export const ERROR_LOADING_ADMIN_TRACKING = "ERROR_LOADING_ADMIN_TRACKING";
